// Navi links: information about navigating outside of current widget, e.g. another widget

import setValue from './keyvalue/actionCreators/setValue';
import getValue from './keyvalue/selectors/getValue';

export const NAVILINKS_KEY = '_widgets_navilinks';

export const setNaviLinks = links => setValue(NAVILINKS_KEY, links);
export const getNaviLink =
  (key, fallback = true) =>
  state =>
    (getValue(NAVILINKS_KEY)(state) || {})[key] ||
    (fallback ? `/${key}` : null);

export const goToNaviLink = link => {
  // safety check that link is an absolute path in current host
  if (link && link[0] === '/') {
    window.location = link;
  }
};
